import { Component } from '@angular/core';
import { DropdownsComponent } from './dropdowns.component';
@Component({
  selector: 'app-dropdowns-req',
  templateUrl: './dropdowns.req.component.html',
  styleUrls: ['./dropdowns.component.css']
})
export class DropdownsReqComponent extends DropdownsComponent {
}
